var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegramN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5334 70.9957C55.1635 70.9957 71.0768 55.1364 71.0768 35.573C71.0768 16.0096 55.1635 0.15033 35.5334 0.15033C15.9033 0.15033 -0.0100098 16.0096 -0.0100098 35.573C-0.0100098 55.1364 15.9033 70.9957 35.5334 70.9957Z",
    fill: "#6FBB45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1584 34.7364C15.1584 34.7364 32.9391 27.4641 39.106 24.9032C41.4698 23.8788 49.4863 20.6009 49.4863 20.6009C49.4863 20.6009 53.1862 19.1671 52.878 22.6497C52.7749 24.0839 51.9529 29.1027 51.1308 34.5316C49.8968 42.2141 48.5611 50.6131 48.5611 50.6131C48.5611 50.6131 48.3557 52.9689 46.6085 53.3787C44.8613 53.7886 41.983 51.9446 41.4695 51.534C41.0583 51.2266 33.7609 46.6172 31.0892 44.3638C30.3695 43.7488 29.5474 42.519 31.1916 41.0859C34.8936 37.7057 39.3114 33.5062 41.9834 30.8432C43.2174 29.6134 44.4515 26.7458 39.3115 30.2283C32.014 35.2475 24.8196 39.9584 24.8196 39.9584C24.8196 39.9584 23.1752 40.9828 20.0916 40.0612C17.008 39.1395 13.4112 37.91 13.4112 37.91C13.4112 37.91 10.9431 36.3735 15.1584 34.7346V34.7364Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramN);
export default __webpack_public_path__ + "static/media/telegram-n.754076dbd0c07f1d21c5705ddee90fc6.svg";
export { ForwardRef as ReactComponent };